<template>
  <el-card
    class="item item-status"
    :class="video.status">
    <el-row class="item__footer">
      <el-col style="flex-shrink: 2;">
        <el-tag
          :style="{
            background: 'none',
                border: 'none',
                 color: statusInfo.color,
          }"
        >{{ statusInfo.label }}</el-tag>
      </el-col>
      <el-col style="text-align: right;">
        <div class="item__buttons">
          <el-button
            size="small"
            @click="openSubmission"
          >
            {{ statusInfo.editable ? 'Edit' : 'View' }}
          </el-button>

          <el-button
            v-if="statusInfo.deletable"
            size="small"
            @click="triggerDelete"
            icon="el-icon-delete"
            class="item__delete"
          ></el-button>
        </div>
      </el-col>
    </el-row>

    <div class="item__body">
      <h2 class="item__title">
        {{ video.title || 'Untitled' }}
        <small class="item__year">
          {{ video.year || '' }}
        </small>
      </h2>
      <p class="item__description">
        {{ video.description_long || '' }}
      </p>
    </div>


  </el-card>

</template>

<script>
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';

export default {
  props: {
    video: {},
  },
  computed: {
    statusInfo() {
      return SUBMISSION_STATUS.getInfo(this.video.status);
    },
  },
  methods: {
    openSubmission() {
      this.$router.push(`submission/${this.video.id}`);
    },
    triggerDelete() {
      this.$confirm(
        `Are you sure you want to delete "<strong>${this.video.title}</strong>"?`,
        'Warning',
        {
          dangerouslyUseHTMLString: true, // `video.title` is expected to be sanitized
          confirmButtonText: 'Delete submission',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => this.deleteSubmission());
    },
    deleteSubmission() {
      return this.$store.dispatch('submission/remove', this.video)
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed',
          });
        })
        .catch((error) => {
          this.$message({
            type: 'error',
            message: `Unable to delete submission. (${error})`,
          });
          throw error;
        });
    },
  },
};
</script>

<style lang="scss">
// Sizing
$item-height: 300px;
$item-button-height: 42px;
$item-body-height: $item-height - $item-button-height - (2 * 20px);
$item-padding-y: 20px;
$item-padding-x: 12px;

// Color
$item-bg-color: #fbfbfb;
$item-color: black;

.item {
  display: flex;
  justify-content: stretch;
  align-items: center;
  position: relative;
  height: initial;
  height: $item-height;
  background-color: $item-bg-color;
  color: $item-color;

   .el-card__body {
    width: 100%;
    height: 100%;
    padding: 0;
    flex-direction: column;
    display: flex;
  }
  .item__body {
    margin-bottom: auto;
    padding: 40px 20px;
    height: $item-body-height;
    overflow: hidden;
  }
  .item__footer {
    box-shadow: 0 1px 1px 0 rgba($item-color,0.1);
    margin-top: auto;
    padding: 1px 10px;
    padding-top: 2px;

    display: flex;
    justify-content: stretch;
    align-items: center;
    background-color: rgba(#000000, 0.02);

    .el-button {
      margin: 0;
      border: none;
      background-color: transparent;
    }
  }
}

.item__title {
  margin-top: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0;
}

.item__description {
  font-size: 0.8em;
  line-height: 1.5em;
  opacity: 0.8;
  // Ellipse text
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item__year {
  font-size: 0.6em;
  opacity: 0.5;
}

.item__delete {
  padding-left: 2px;
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ListItem.vue